export const INVITATION_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  ARCHIVED: "archived",
};

export const STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "published", label: "Published" },
  { value: "archived", label: "Archived" },
];

export const TEMPLATE_OPTIONS = [
  {
    id: "TMP001",
    name: "Royal Gold",
    primaryColor: "#D4AF37",
    secondaryColor: "#FFFFFF",
  },
  {
    id: "TMP002",
    name: "Rose Elegance",
    primaryColor: "#C9184A",
    secondaryColor: "#FFF0F3",
  },
  {
    id: "TMP003",
    name: "Emerald Charm",
    primaryColor: "#046A38",
    secondaryColor: "#F5FFF7",
  },
  {
    id: "TMP004",
    name: "Classic Ivory",
    primaryColor: "#8B7355",
    secondaryColor: "#FFFDF7",
  },
];

export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to fetch invitations. Please try again.",
  FETCH_ONE_FAILED: "Failed to fetch invitation details.",
  CREATE_FAILED: "Failed to create invitation. Please try again.",
  UPDATE_FAILED: "Failed to update invitation. Please try again.",
  DELETE_FAILED: "Failed to delete invitation. Please try again.",
  UPLOAD_FAILED: "Failed to upload image. Please try again.",
  NOT_FOUND: "Invitation not found.",
  TITLE_REQUIRED: "Invitation title is required",
  EVENT_DATE_REQUIRED: "Event date is required",
};

export const SUCCESS_MESSAGES = {
  CREATE_SUCCESS: "Invitation created successfully!",
  UPDATE_SUCCESS: "Invitation updated successfully!",
  DELETE_SUCCESS: "Invitation deleted successfully!",
  PUBLISH_SUCCESS: "Invitation published successfully!",
  IMAGE_UPLOADED: "Image uploaded successfully!",
};
